import { PlanType } from '@otter-ai/recall-client';

export function getPlanTitle(plan: PlanType) {
  switch (plan) {
    case 'premium':
      return 'plan_pro';
    case 'team':
      return 'plan_business';
    // self serve enterprise could be added in the future
    // case 'enterprise':
    //   return 'Enterprise';
    default:
      return 'plan_default';
  }
}
